import { Component, Input, OnInit, ViewChild } from '@angular/core';
import coi from 'src/app/data/constants/ConflictOfInterest.json'
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApprovingOfficerSummary, VendorDetails, VendorDocument, WorkflowHeader } from 'src/app/shared/models/database-models/ApprovingOfficerSummary.model';
import { Subject, lastValueFrom, takeUntil } from 'rxjs';
import ProcessType from 'src/app/data/constants/ProcessType.json';
import { DatePipe, DecimalPipe } from '@angular/common';
import { DropDownOptions, ExtendedGLAccount, ExtendedMaterialSubGroup, PurchaseType, StoreDropdowns } from 'src/app/shared/models/app-models';
import { AttachmentTypeIdEnum, ScopeOfWorkAttachment, TenderDocumentAttachment, Actioner, SaveMyPurchase } from 'src/app/shared/models/database-models';
import { BackendApiService } from '../../../core/services/backend-api';
import { BudgetAllocationSummary, IItemToRequest, WOCReason } from '../../../shared/models/app-models/MyPurchaseForm.model';
import { Store } from '@ngrx/store';
import { ExtendedWOCReason } from '../../../shared/models/app-models/ExtendedWOCReason.model';
import { ExtendedDOTPReason } from '../../../shared/models/app-models/ExtendedDOTPReason.model';
import { AlertType } from 'src/app/shared/components/alert/alert.component';
import { OthersBudget } from "src/app/shared/models/sap-models/otherBudget";
import { WBSBudget } from "src/app/shared/models/sap-models/wbsBudget";
import { environment } from 'src/environments/environment';
import { WorflowHistory } from 'src/app/shared/models/app-models/Approving.model';
import { UserInformation } from 'src/app/shared/models/app-models/UserInformation.model';
import { FormTransformerPipe } from 'src/app/shared/pipes/form-transformer/form-transformer.pipe';
import { getCapitalAUCAllocations, getProjectBudgetAllocations } from '../../shared/utils/derive-budget-allocations';
import { getCapitalAUCAllocationsForRO, getCapitalBudgetAllocationsWithFinancialYearForRO, getOperatingBudgetAllocationsCWithFinancialYearForRO, getProjectBudgetAllocationsForRO } from '../../shared/utils/derive-budget-allocations-for-ro';
import { NoticeService } from 'src/app/core/services/notice.service';
import { FileService } from 'src/app/shared/services/file.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RfsInfoDialogComponent } from '../../mypurchase-form/rfs-info-dialog/rfs-info-dialog.component';


interface PurchaseDetails {
  purchaseMode: string;
  process: string;
  purposeOfPurchase: string;
  pemissibleReason: string;
}

interface BudgetAllocation {
  budgetType: string;
  budgetCostCentre: string;
  glAccount: string;
  orderNo: string;
  budgetAvailability: string;
  totalAmount: string;
  budgetBalance: string;
  expenditureUsage: string;
  frequencyUsage: string;
  excoApproval: boolean;
  exemptedAmount: string;
}

@Component({
  selector: 'app-approving-overview',
  templateUrl: './approving-overview.component.html',
  styleUrls: ['./approving-overview.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [
    {
      provide: DatePipe,
    },
    {
      provide: DecimalPipe
    }
  ],
})
export class AoOverviewComponent implements OnInit {
  public AttachmentTypeId = AttachmentTypeIdEnum;
  @Input() ApprovingOfficerSummary!: ApprovingOfficerSummary;
  @Input() currentWorkflow!: WorkflowHeader;
  @Input() mpDocumentDraftDetails!: SaveMyPurchase;
  destroy$: Subject<boolean> = new Subject<boolean>();
  // data
  purchaseDetails: PurchaseDetails = {
    purchaseMode: "",
    process: "",
    purposeOfPurchase: "",
    pemissibleReason: ","
  };
  coi = coi.conflictOfInterest;
  mpProcessType = ProcessType;
  isCapital: boolean = false;
  spaceRequirement: string = "";
  vendors: VendorDetails[] = []
  ItemTableData: IitemInfo[] = [];
  itemListFormat: IItemToRequest[] = [];
  // table
  newDataSource = new MatTableDataSource<RoBudgetAllocationSummary>();
  itemsDataSource = new MatTableDataSource<itemBudgetInfo>();
  // vendorDocumntDataSource = new MatTableDataSource<VendorDocument>();
  columnsToDisplay = ['budgetType', 'budgetCostCentre', 'glAccount', 'orderNo', 'budgetAvailability', 'financialYear', 'totalAmount', 'AorExemptedAmount', 'budgetBalance', 'expenditureUsage', 'frequencyUsage', 'excoApproval'];
  columnsToDisplayForItemBudget=['ItemNo','MatSubGrp','ItemDesc','PartNum','Qty','UoM','Currency','UnitPrice','itemAmount','BudgetsInvolved','DistType','DistShare','DistAmount'];
  columnsToDisplayItemBudgetWithExpand:string[] = ['expand',...this.columnsToDisplayForItemBudget];
  columnsToDisplayVendorDocument = ['Filename', 'VendorsToReceive'];
  capitalUsageRequirmentDataSource = new MatTableDataSource<CapitalUsageRequirement>();
  columnsToDisplayWithExpandVendorDocument: string[] = ['expand', ...this.columnsToDisplayVendorDocument];
  columnsToDisplaCapitalUsage = ['itemno', 'budgetCostCentre', 'itemDescription', 'itemAmount', 'estimatedAsset', 'IsAdditionalSpaceRequired', 'AnnualMaintenanceCost','IsSupportingNonFundingProject', 'SupportingInformation'];
  columnsToDisplaCapitalUsageWithExpand: string[] = [...this.columnsToDisplaCapitalUsage];
  expandedElement: BudgetAllocation | null = null;
  public PurchaseTypeEnum = PurchaseType;
  scopeOfWorkAttachment: ScopeOfWorkAttachment[] = [];
  tenderDocumentAttachment: TenderDocumentAttachment[] = [];
  approvalDocumentAttachment: ScopeOfWorkAttachment[] = [];
  quotationDocumentAttachment: ScopeOfWorkAttachment[] = [];
  supportingDocumentAttachment: ScopeOfWorkAttachment[] = [];
  vendorDocumentAttachment: VendorDocument[] = [];
  storeDropdowns!: StoreDropdowns
  username: string = ''
  fileReference: any = {};
  isLoadingSAPData:boolean = true;
  issapTimeout:boolean = false;
  issapTimeoutAlert:boolean = false;
  DialogRef: MatDialogRef<RfsInfoDialogComponent> | null = null
  wocReason: any = {
    id: '',
    content: '',
    tooltips: '',
    code: ''
  }
  dotpReason: any = {
    id: '',
    Reason: '',
    code: ''
  }
  attachment:any = [];
  showProjectCompletionMessage: boolean = false;
  budgetNames: string = ''
  actioner: Actioner = {
    approver: [],
    recommender: [],
    endorser: [],
    endorsed: [],
    releaser: [],
    recommended: [],
    approved: []
  };
  formattedBudgetSummaries: any = [];
  itemsFilterFormatted: BudgetItemGroup[] = [];
  expandedBudgets = new Set();
  materialSubGroups: ExtendedMaterialSubGroup[] = [];
  costCentreDropDownOptions: DropDownOptions[] = [];
  fundCentreDropDownOptions: DropDownOptions[] = [];
  originalProjectBudgetDropDownOptions: any[] = [];
  originalGLAccountDropDownOptions: ExtendedGLAccount[] = [];



  ATTACHMENTS_BY_PURCHASE_TYPE: Record<string, string[]>;
  documentStatusAttachments: string[] = ['vendor', 'supporting', 'quotation', 'approvals', 'sow', 'tender'];
  availableDocAttachments: string[] = [];
  selectedAttachments = new Set<string>(this.availableDocAttachments);
  allAttachmentTypes = [
    { type: 'vendor', label: 'Document to vendor' },
    { type: 'supporting', label: 'Supporting Document' },
    { type: 'quotation', label: 'Quotation' },
    { type: 'approvals', label: 'Management Approval' },
    { type: 'sow', label: 'Scope of Work' },
    { type: 'tender', label: 'Tender Documents' }
  ];
  pageSizeOptions: number[] = [5, 10, 20, 50];
  defaultPageSize = 5;

  private itemPaginator!: MatPaginator;
  private capReqPaginator!:MatPaginator;
  private budgetPaginator!: MatPaginator;

  @ViewChild('itemPaginator', { read: MatPaginator })
  set matItemPaginator(mp: MatPaginator) {
    this.itemPaginator = mp;
    this.itemsDataSource.paginator = this.itemPaginator;
  }

  @ViewChild('capReqPaginator', { read: MatPaginator })
  set matCapReqPaginator(crp: MatPaginator) {
    this.capReqPaginator = crp;
    this.capitalUsageRequirmentDataSource.paginator = this.capReqPaginator;
  }

  @ViewChild('budgetPaginator', { read: MatPaginator })
  set matBudgetPaginator(bp: MatPaginator) {
    this.budgetPaginator = bp;
    this.newDataSource.paginator = this.budgetPaginator;
  }

    constructor(
    private datePipe: DatePipe,
    public fileService: FileService,
    private backendService: BackendApiService,
    public noticeService: NoticeService,
    private transformer: FormTransformerPipe,
    private dialog: MatDialog,
    private decimalPipe: DecimalPipe,
    private store: Store<{
      dp: StoreDropdowns;
      user: UserInformation;
    }>) {
    this.store.select('user').pipe(takeUntil(this.destroy$)).subscribe((user: UserInformation) => {
      this.username = user.userName;
    })
      this.ATTACHMENTS_BY_PURCHASE_TYPE = {
        [this.PurchaseTypeEnum.RFQ]: ['vendor', 'supporting', 'quotation', 'approvals'],
        [this.PurchaseTypeEnum.CORPORATE_CARD]: ['vendor', 'supporting', 'quotation', 'approvals'],
        [this.PurchaseTypeEnum.PCPO]: ['supporting', 'quotation', 'approvals'],
        [this.PurchaseTypeEnum.TENDER]: ['supporting', 'approvals', 'sow', 'tender'],
        [this.PurchaseTypeEnum.DC]: ['supporting', 'approvals', 'sow', 'tender'],
        [this.PurchaseTypeEnum.ONLINE]: ['vendor', 'supporting', 'quotation', 'approvals']
      };
    

  }

  async ngOnInit(): Promise<void> {
    this.store.select('dp').pipe(takeUntil(this.destroy$)).subscribe((dp: StoreDropdowns) => {
      this.storeDropdowns = dp;
      this.wocReason = (dp.WOCReasons as ExtendedWOCReason[]).find(i => i.code === this.ApprovingOfficerSummary.WaiverOfCompetition?.WOCCode)
      this.dotpReason = (dp.DOTPReasons as ExtendedDOTPReason[]).find(i => i.id === this.ApprovingOfficerSummary.DOTP?.DOTPReasonId)
      this.materialSubGroups = dp.MaterialSubGroup as ExtendedMaterialSubGroup[];
      this.fundCentreDropDownOptions = dp.FundCentre;
      this.costCentreDropDownOptions = dp.CostCentre;
      this.originalProjectBudgetDropDownOptions = dp.ProjectBudget;
      this.originalGLAccountDropDownOptions = dp.GLAcc as ExtendedGLAccount[];
    });
    try {
      // set details of the purchase
      this.purchaseDetails = {
        purchaseMode: this.ApprovingOfficerSummary.purchaseType,
        process: this.ApprovingOfficerSummary.DOTP
          ? this.currentWorkflow.workflow_id === 'WOCApproval' ||
            this.currentWorkflow.workflow_id === 'DOTPApproval'
            ? 'Approval of WOC/DOTP​'
            : this.mpProcessType.find(
              (processType) =>
                processType['dag-workflow-name'] ==
                this.currentWorkflow?.workflow_id
            )?.ProcessName ?? ''
          : this.mpProcessType.find(
            (processType) =>
              processType['dag-workflow-name'] ==
              this.currentWorkflow?.workflow_id
          )?.ProcessName ?? '',
        purposeOfPurchase: this.ApprovingOfficerSummary.Purpose,
        pemissibleReason: (this.ApprovingOfficerSummary
          .OtherPermissibleReasons ||
          this.ApprovingOfficerSummary.PermissibleReasons) as string,
      };
      // display all the budgets grouped by workflow header
      //var itemBudgetData: RoBudgetAllocationSummary[] = [];
      if (this.newDataSource.data.length == 0) {
        this.formattedBudgetSummaries= await this.loadData();
        this.newDataSource.data = this.formattedBudgetSummaries;
        this.getSAPBudget(this.formattedBudgetSummaries);
      }
      let CapitalUsageRequirement = await this.loadCapitalUsageRequirementData()
      this.capitalUsageRequirmentDataSource.data = CapitalUsageRequirement;
      if (this.wocReason) {
        await this.getWOCFiles(this.wocReason?.code)
      }
      this.vendors = this.ApprovingOfficerSummary.mpVendorDetails
      this.scopeOfWorkAttachment =
        this.ApprovingOfficerSummary.Attachment?.filter(
          (item: ScopeOfWorkAttachment) =>
            +item.AttachmentTypeId === AttachmentTypeIdEnum.SCOPE_OF_WORK
        ) || [];
      this.tenderDocumentAttachment =
        this.ApprovingOfficerSummary.Attachment?.filter(
          (item: ScopeOfWorkAttachment) =>
            item.AttachmentTypeId == AttachmentTypeIdEnum.INVITATION_TO_TENDER ||
            item.AttachmentTypeId == AttachmentTypeIdEnum.SECTION_CONDITION_TO_TENDER ||
            item.AttachmentTypeId == AttachmentTypeIdEnum.SECTION_CONDITION_TO_CONTRACT ||
            item.AttachmentTypeId == AttachmentTypeIdEnum.SECTION_SCOPE_OF_WORK ||
            item.AttachmentTypeId == AttachmentTypeIdEnum.SECTION_TENDER_RESPONSE_FORM
        ) || [];
      this.approvalDocumentAttachment =
        this.ApprovingOfficerSummary.Attachment?.filter(
          (item: ScopeOfWorkAttachment) =>
            item.AttachmentTypeId == AttachmentTypeIdEnum.RESTRICTED_IT_PRODUCT_SD ||
            item.AttachmentTypeId == AttachmentTypeIdEnum.RESTRICTED_IT_PRODUCT_SD_CDO ||
            item.AttachmentTypeId == AttachmentTypeIdEnum.SD_APPROVAL
        ) || [];
      this.quotationDocumentAttachment =
        this.ApprovingOfficerSummary.Attachment?.filter(
          (item: ScopeOfWorkAttachment) =>
            item.AttachmentTypeId == AttachmentTypeIdEnum.QUOTATION
        ) || [];
      this.supportingDocumentAttachment =
        this.ApprovingOfficerSummary.Attachment?.filter(
          (item: ScopeOfWorkAttachment) =>
            item.AttachmentTypeId == AttachmentTypeIdEnum.SUPPORTING_DOCUMENT
        ) || [];
      this.vendorDocumentAttachment =
        this.ApprovingOfficerSummary.Attachment?.filter(
          (attachment: ScopeOfWorkAttachment) =>
            attachment.AttachmentTypeId === AttachmentTypeIdEnum.DOCUMENT_TO_VENDOR
        ).map((attachment: ScopeOfWorkAttachment) => {
          const taggedVendorNames = (attachment.taggedVendors || [])
            .map(taggedId => this.vendors.find(v => v.VendorNumber === taggedId)?.Name)
            .filter(name => !!name)
            .join(', ');

          return {
            ...attachment,
            taggedVendorNames
          };
        }) || [];
      this.generateProjectCompletionMessage(this.ApprovingOfficerSummary.workflowHeader)
      this.setAvailableAttachments();
      this.setSelectedAttachments();
        this.itemsDataSource.data=this.getItemTableData(this.ApprovingOfficerSummary?.itemList);
    }
    catch (e) {
      console.log(e)
    }
  }

  getItemTableData(itemList: any[]): itemBudgetInfo[] {
    if (!itemList || !Array.isArray(itemList)) return [];
  
    const filterSet = new Map<string, BudgetItemGroup>();
  
    const result = itemList.map((item: any) => {
      const budgetGroups = this.getFormattedBudgetGroup(item.budgetAllocation || []);
  
      // Collect unique groupKey-based entries
      budgetGroups.forEach(bg => {
        if (!filterSet.has(bg.groupKey)) {
          filterSet.set(bg.groupKey, bg);
        }
      });
  
      return {
        ItemNo: item.ItemNumber,
        MatSUbGrp: item.MaterialSubGroupId,
        ItemDesc: item.ItemDescription,
        PartNum: item.PartModelNumber ?? '-',
        Qty: item.itemPrice?.Quantity,
        UoM: item.itemPrice?.UnitOfMeasurement,
        Currency: item.itemPrice?.CurrencyCode,
        UnitPrice: item.itemPrice?.EstimateUnitPrice,
        itemAmount:item.itemPrice?.EstimateUnitPrice * item.itemPrice?.Quantity,
        BudgetsInvolved: budgetGroups,
        originalAllocations: item.budgetAllocation || []
      };
    });
  
    // Store the final unique, flattened budget group list
    this.itemsFilterFormatted = Array.from(filterSet.values());
  
    return result;
  }
  getFormattedBudgetGroup(budgetList: any[]): BudgetItemGroup[] {
    return budgetList.map(budget => {
      let centre = '';
      let gl = '';

      if (budget.BudgetType === 'Operating') {
        centre = this.costCentreDropDownOptions?.find((subGroup: any) => subGroup.id === budget.OVCostCentre)?.value || '';
        gl = this.originalGLAccountDropDownOptions?.find((subGroup: any) => subGroup.Code === budget.OVGLAccount)?.value || '';
      } else if (budget.BudgetType === 'Capital') {
        centre = this.fundCentreDropDownOptions?.find((subGroup: any) => subGroup.id === budget.CVFundCentre)?.value || '';
        gl = this.originalGLAccountDropDownOptions?.find((subGroup: any) => subGroup.Code === budget.CVGLAccount)?.value || '';
      } else if (budget.BudgetType === 'Capital AUC') {
        centre = this.originalProjectBudgetDropDownOptions?.find((subGroup: any) => subGroup.Code === budget.CAUCVCapitalBudget)?.value || '';
        gl = this.originalGLAccountDropDownOptions?.find((subGroup: any) => subGroup.Code === budget.CAUCVGLAccount)?.value || '';
      } else {
        centre = this.originalProjectBudgetDropDownOptions?.find((subGroup: any) => subGroup.Code === budget.PVProjectBudget)?.value || '';
        gl = this.originalGLAccountDropDownOptions?.find((subGroup: any) => subGroup.Code === budget.PVGLAccount)?.value || '';
      }
  
      const type = budget.BudgetType || '';
      const groupKey = `${type} - ${centre} / ${gl}`;
  
      return {
        type,
        centre,
        gl,
        groupKey
      };
    });
  }
  getDistributionType(element: any, index: number): string {
    const alloc = element.originalAllocations?.[index];
    if (!alloc) return 'NA';
    return alloc.DistributionQuantity ? 'Quantity' : 'Percentage';
  }

  getDistributionShare(element: any, index: number): string {
    const alloc = element.originalAllocations?.[index];
    if (!alloc) return 'NA';

    // Check for quantity-based distribution
    if (alloc.DistributionQuantity) {
      const totalQty = element.originalAllocations.reduce((sum: number, a: any) => sum + (a.DistributionQuantity || 0), 0);
      const qty = alloc.DistributionQuantity || 0;
      return totalQty > 0 ? `${qty}/${totalQty}` : 'NA';
    }

    // Fallback to percent-based distribution
    if (alloc.DistributionPercent) {
      return `${alloc.DistributionPercent}%`;
    }

    return 'NA';
  }

  getDistributionAmount(element: any, index: number): string {
    const alloc = element.originalAllocations?.[index];
    const totalAmount = element.itemAmount;

    if (!alloc || totalAmount == null) return 'NA';

    if (alloc.DistributionQuantity) {
      const totalQty = element.originalAllocations.reduce(
        (sum: number, a: any) => sum + (a.DistributionQuantity || 0),
        0
      );

      if (totalQty === 0) return 'NA';

      const qty = alloc.DistributionQuantity;
      const shareRatio = qty / totalQty;
      const distAmount = shareRatio * totalAmount;

      return distAmount.toFixed(2); // round to 2 decimal places
    }

    if (alloc.DistributionPercent) {
      const totalAmount = element.itemAmount;

      const distAmount = alloc.DistributionPercent / 100 * totalAmount;
      return distAmount.toFixed(2); // round to 2 decimal places
    }
    return 'NA';
  }

  formatMaterialSubGroupId(id: String): any {
    const subGropuname = this.materialSubGroups?.find((subGroup: any) => subGroup.Code === id);
    return subGropuname?.value;
  }

  async returnWorkflowHeadersWithBudgetAvailabilityDetails(workflow: WorkflowHeader, budgetSummary:RoBudgetAllocationSummary){
    let budgetAvalAmount;
        let aorAmount;
        let deliveryDate =`${budgetSummary.EndFinancialYear}0331`
        if(workflow.budgetType == 'Operating'){
          budgetAvalAmount = Number(await this.operatingBudgetAvailable(workflow.budgetCostCentreCode, workflow.GLAccountCode, workflow.BudgetOrderNo,deliveryDate));
          aorAmount = budgetSummary.totalAmount - workflow.exemptedAmount;
        }else if(workflow.budgetType == 'Capital' ) {
          budgetAvalAmount = Number(await this.capitalBudgetAvailable(workflow.budgetCostCentreCode, workflow.GLAccountCode, workflow.BudgetOrderNo,deliveryDate));
          aorAmount = budgetSummary.totalAmount;
        }else if(workflow.budgetType == 'Capital AUC' ) {
          budgetAvalAmount = Number(await this.capitalBudgetAUCAvailable(workflow.BudgetOrderNo));
          aorAmount = budgetSummary.totalAmount;
        }else{
          budgetAvalAmount = Number(await this.projectBudgetAvailable(workflow.BudgetOrderNo));
          aorAmount = budgetSummary.aorAmount;
        }
        if(this.issapTimeout && !this.issapTimeoutAlert){
          this.DialogRef = this.dialog.open(RfsInfoDialogComponent, {
            // height: '210px',
            // width: '280px',
            data: {
              title: "Connection Timed Out",
              content: `Please refresh your page and try again.` as any as InnerHTML
            }
          })
          this.issapTimeoutAlert = true;
        }
        let BudgetAvail= 0;
        let BudgetBalance= 0;
        if(budgetAvalAmount){
            BudgetAvail = budgetAvalAmount;
            BudgetBalance = budgetAvalAmount - aorAmount;
        }
        await this.getCoveringofficer(workflow);
        let itemBudget: RoBudgetAllocationSummary = {
          ...budgetSummary,
          aorAmount: aorAmount,
          orderNo: workflow.budgetType !== 'Project'  ? workflow.BudgetOrderNo:"",
          budgetAvailability: ( 
            (workflow.approver && (workflow.approver.split(',').includes(this.username) || this.actioner.approver.includes(this.username)) )
            || 
            (workflow.approved && (workflow.approved.split(',').includes(this.username) || this.actioner.approved.includes(this.username)) )
            || 
            (workflow.recommender && (workflow.recommender.split(',').includes(this.username) || this.actioner.recommender.includes(this.username)) )
             ||
            (workflow.recommended && (workflow.recommended.split(',').includes(this.username) || this.actioner.recommended.includes(this.username)) )
             ||
            (workflow.releaser && (workflow.releaser.split(',').includes(this.username) || this.actioner.releaser.includes(this.username)) )
            ||
            (workflow.endorser  && (workflow.endorser.split(',').includes(this.username) || this.actioner.endorser.includes(this.username)) )
            ||
            (workflow.endorsed && (workflow.endorsed.split(',').includes(this.username) || this.actioner.endorsed.includes(this.username)) )
          ) 
          ? BudgetAvail.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) : '-' ,
          budgetBalance: 
          (
            (workflow.approver && (workflow.approver.split(',').includes(this.username) || this.actioner.approver.includes(this.username)) )
            || 
            (workflow.approved && (workflow.approved.split(',').includes(this.username) || this.actioner.approved.includes(this.username)) )
            || 
            (workflow.recommender && (workflow.recommender.split(',').includes(this.username) || this.actioner.recommender.includes(this.username)) )
             ||
            (workflow.recommended && (workflow.recommended.split(',').includes(this.username) || this.actioner.recommended.includes(this.username)) )
             ||
            (workflow.releaser && (workflow.releaser.split(',').includes(this.username) || this.actioner.releaser.includes(this.username)) )
            ||
            (workflow.endorser && (workflow.endorser.split(',').includes(this.username) || this.actioner.endorser.includes(this.username)) )
            ||
            (workflow.endorsed && (workflow.endorsed.split(',').includes(this.username) || this.actioner.endorsed.includes(this.username)) )
          )
          ? BudgetBalance.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) : "-",
          exemptedAmount: workflow.budgetType == 'Operating' ? workflow.exemptedAmount?.toString() : "",
          exco:workflow.isEXCOBoard ? "Yes" : "No" ,
        }
        return itemBudget    
  }
  findWorkflowHeaderForEachBudgetSummary(budgetSummary: RoBudgetAllocationSummary) {
    if (budgetSummary.budgetType == 'Operating')
      return this.ApprovingOfficerSummary.workflowHeader.find(x => x.budgetType == 'Operating' && x.budgetCostCentre == budgetSummary.costCentre && x.GLAccount == budgetSummary.glAccount && x.isBudgeted === budgetSummary.expenditure && x.isRecurrent === budgetSummary.frequency)
    else if (budgetSummary.budgetType == 'Capital')
      return this.ApprovingOfficerSummary.workflowHeader.find(x => x.budgetType == 'Capital' && x.budgetCostCentre == budgetSummary.fundCentre && x.GLAccount == budgetSummary.glAccount && x.isBudgeted === budgetSummary.expenditure)
    else if (budgetSummary.budgetType == 'Capital AUC')
      return this.ApprovingOfficerSummary.workflowHeader.find(x => x.budgetType == 'Capital AUC' && x.budgetCostCentre == budgetSummary.projectBudget && x.GLAccount == budgetSummary.glAccount && x.isBudgeted === budgetSummary.expenditure)
    else
    return this.ApprovingOfficerSummary.workflowHeader.find(x => x.budgetType == 'Project' && x.budgetCostCentre == budgetSummary.projectBudget && x.GLAccount == budgetSummary.glAccount)
  }
  navigateToRO(DocumentNo: string, purchaseType: string) {
    let url: string = '';
    switch (purchaseType) {
      case PurchaseType.RFQ:
        url = '/purchase/rfq/' + `${DocumentNo}`;
        break;
      case PurchaseType.TENDER:
        url = '/purchase/tender/' + `${DocumentNo}`;
        break;
      case PurchaseType.ONLINE:
        url = '/purchase/corporatecard/' + `${DocumentNo}`;
        break;
      case PurchaseType.PERMISSIBLE_COVERING:
        url = '/purchase/permissiblecoveringpurchaseorder/' + `${DocumentNo}`;
        break;
      case PurchaseType.DC:
        url = '/purchase/dc/' + `${DocumentNo}`;
        break;
      case PurchaseType.CORPORATE_CARD:
        url = '/purchase/corporatecard/' + `${DocumentNo}`;
        break;
      case PurchaseType.PM:
        url = '/purchase/permissiblecoveringpurchaseorder/' + `${DocumentNo}`;
        break;
    }
    window.open(url, '_blank');
  }
  async loadData() {
    // let saveMyPurchase = await lastValueFrom(this.backendService.getDraft(this.ApprovingOfficerSummary.MPDocumentNumber))
    let myPurchaseForm = this.transformer.transformInverse(this.mpDocumentDraftDetails, this.storeDropdowns)
    let itemList = myPurchaseForm.ItemList.filter(x => !x.isDeleted && !x.Strikethrough)
    this.itemListFormat = myPurchaseForm.ItemList.filter(x => !x.isDeleted && !x.Strikethrough)
    let allBudgetAllocationForms = itemList.flatMap(x => x.BudgetAllocation.filter(y => !y.isDeleted && !y.Strikethrough))
    let operatingBudgetAllocations = getOperatingBudgetAllocationsCWithFinancialYearForRO(allBudgetAllocationForms, itemList)
    let capitalBudgetAllocations = getCapitalBudgetAllocationsWithFinancialYearForRO(allBudgetAllocationForms, itemList)
    let capitalAucBudgetAllocations = getCapitalAUCAllocationsForRO(allBudgetAllocationForms, itemList)
    let projectBudgetAllocations = await Promise.all(getProjectBudgetAllocationsForRO(allBudgetAllocationForms, itemList, myPurchaseForm.generalForm))
    let allBudgetSummaries: RoBudgetAllocationSummary[] =  operatingBudgetAllocations.concat(capitalAucBudgetAllocations).concat(capitalBudgetAllocations).concat(projectBudgetAllocations).map( x => {

    let oneBudget = allBudgetAllocationForms.find(y => y.BudgetType.id == x.budgetType)

    // let budgetAvalAmount;
    // let aorAmount;
    // if(x.budgetType == 'Operating'){
    //   if(x.costCentreId && x.glAccountId){
    //     budgetAvalAmount = Number(await this.operatingBudgetAvailable(x.costCentreId, x.glAccountId, x.orderNo));
    //     aorAmount = x.totalAmount - x.aorExemptedAmount;
    //   }
    //   let workflowInfo = this.ApprovingOfficerSummary.workflowHeader.find(y => 
    //     y.budgetType == x.budgetType 
    //     && y.budgetCostCentre == x.costCentre
    //     && y.GLAccount == x.glAccount
    //   )
    //   await this.getCoveringofficer(workflowInfo!);
      
    // }
    // else if(workflow.budgetType == 'Capital' ) {
    //   budgetAvalAmount = Number(await this.capitalBudgetAvailable(workflow.budgetCostCentreCode, workflow.GLAccountCode, workflow.BudgetOrderNo));
    //   aorAmount = workflow.totalAmount;
    // let workflowInfo = this.ApprovingOfficerSummary.workflowHeader.find(y => 
    //   y.budgetType == x.budgetType 
    //   && y.budgetCostCentre == x.fundCentre
    //   && y.GLAccount == x.glAccount
    // )
    // await this.getCoveringofficer(workflowInfo!);
    // }else if(workflow.budgetType == 'Capital AUC' ) {
    //   budgetAvalAmount = Number(await this.capitalBudgetAUCAvailable(workflow.BudgetOrderNo));
    //   aorAmount = workflow.totalAmount;
    //  workflowInfo = this.ApprovingOfficerSummary.workflowHeader.find(y => 
    //   y.budgetType == x.budgetType 
    //   && y.budgetCostCentre == x.projectBudget
    //   && y.GLAccount == x.glAccount
    // )
    // await this.getCoveringofficer(workflowInfo!);
    // }else{
    //   budgetAvalAmount = Number(await this.projectBudgetAvailable(workflow.BudgetOrderNo));
    //   aorAmount = workflow.totalAmount;

    //  workflowInfo = this.ApprovingOfficerSummary.workflowHeader.find(y => 
    //   y.budgetType == x.budgetType 
    //   && y.budgetCostCentre == x.projectBudget
    //   && y.GLAccount == x.glAccount
    // )
    // await this.getCoveringofficer(workflowInfo!);
    // }


      return {
        ...x,
        budgetAvailability: "",
        budgetBalance: "",
        exemptedAmount: "",
        // expenditure: typeof (oneBudget?.BudgetExpenditureUsage?.id) == 'boolean' ? oneBudget?.BudgetExpenditureUsage?.id : null,
        expenditure: x.budgeted === 'Budgeted' ? true : false,
        spaceReq: null,
        exco:  null,
        // frequency: typeof (oneBudget?.BudgetFrequencyUsage?.id) == 'boolean' ? oneBudget?.BudgetFrequencyUsage?.id : null
        frequency: x.reccurent === 'Recurrent' ? true : false
      }
    }
    )
    return allBudgetSummaries
  }
  async loadCapitalUsageRequirementData() {
   let itemTableData = await this.convertToTable(this.itemListFormat);
   let allBudgetAllocationForms = this.itemListFormat.flatMap(x => x.BudgetAllocation.filter(y => !y.isDeleted && !y.Strikethrough))
   let filteredData = allBudgetAllocationForms.map(budget => {
        const FilteredItem = itemTableData.find((items:any) => items.displayItemNumber === budget.displayPurchaseItemNumber);
        return { 
          itemno:budget.displayPurchaseItemNumber,
          budgetCostCentre: budget.BudgetType.value === 'Capital' ? budget.FundCentre?.value : budget.ProjectBudget?.value,
          itemDescription:FilteredItem?.ItemDescription,
          itemAmount:FilteredItem?.TotalAmount,
          IsAdditionalSpaceRequired:FilteredItem?.spaceRequirement,
          AnnualMaintenanceCost:FilteredItem?.amountMaintenance,
          IsSupportingNonFundingProject:FilteredItem?.projectCofunding,
          SupportingInformation:FilteredItem?.reasonDescription,
          EstimatedAsset: FilteredItem?.estimatedAsset,
          BudgetType:budget.BudgetType.value
         };
      })
      .filter(item => item !== null && (item.BudgetType === 'Capital' || item.BudgetType === 'Capital AUC'));
    return filteredData
  }
  async convertCurrencyToSGD(amount: number, currCode: string, exchangeRateCurrency:number) {
    if (currCode == 'SGD') return amount
    return (amount * (exchangeRateCurrency))
  }
  async convertToTable(itemList: IItemToRequest[]) {
    let tableTable: IitemInfo[] = [];
    let estimatedTotal: number = 0.0;
    for (const item of itemList) {
      let totalAmountInItemCurrency =
        ((item.ItemPrice.Quantity) * item.ItemPrice.UnitPrice) /
        item.ItemPrice.UnitsPerQuantity;
      if (!item.isDeleted && !item.Strikethrough) {
        let totalAmount = await this.convertCurrencyToSGD(totalAmountInItemCurrency, item.ItemPrice.Currency.value, item.ItemPrice.ExchangeRate)
        estimatedTotal += totalAmount;
      }
      let IsSupportingNonFundingProject:string  = item.AddItems.IsSupportingNonFundingProject ? 'Yes': 'No'
      let IsAdditionalSpaceRequired: string = item.AddItems?.IsAdditionalSpaceRequired || (this.currentWorkflow?.spaceRequirement && this.currentWorkflow?.spaceRequirement > 0)
        ? 'Yes'
        : 'No';
      let tableObj: IitemInfo = {
        displayItemNumber: item.AddItems.displayItemNumber,
        ItemDescription: item.AddItems.ItemDescription ?? null,
        TotalAmount: this.decimalPipe.transform(totalAmountInItemCurrency, '1.2-2') ?? '0.00',
        isDeleted: item.isDeleted ? true : false,
        Strikethrough: item.Strikethrough,
        amountMaintenance: item.AddItems.AnnualMaintenanceCost ?? '-',
        estimatedAsset: item.AddItems.EstimatedUsageId?.Name ?? '-',
        projectCofunding: IsSupportingNonFundingProject  ?? 'No',
        reasonDescription: item.AddItems.SupportingInformation ?? '-',
        spaceRequirement: IsAdditionalSpaceRequired ?? 'No',
        BudgetCode:item.BudgetAllocation[0].FundCentre?.value
      };
      tableTable.push(tableObj);
    }
    return tableTable;
  }
  fontTextColor(balance: string): string {
    let totalBalance = parseFloat(balance.replace(/,/g, ''));
    return Number(totalBalance) >= 0 ? 'text-color-green' : 'text-color-red';
  }
  async operatingBudgetAvailable(budgetCostCentreCode: string, GLAccountCode: string, BudgetOrderNo: string, deliveryDate:string) {
    try {
      const table_fp = environment.table_fp;
      const table_cb = environment.table_cb;
      var record: OthersBudget = await lastValueFrom(this.backendService.checkBudgetOTH("", budgetCostCentreCode, GLAccountCode, BudgetOrderNo, deliveryDate, table_fp, table_cb));
      console.log("BUDGET_AVAL for Operation", record.BUDGET_AVAL)
      return Number(record.BUDGET_AVAL);
    }
    catch (err) {
      this.issapTimeout = true;
      console.log('Error in fetching the data from SAP ', err);
      return 0;
    }
  }

  async getCoveringofficer(data: WorkflowHeader) {
    try {
      let approver: string[] = [];
      let recommender: string[] = [];
      let endorser: string[] = [];
      let endorsed: string[] = [];
      let releaser: string[] = [];
      let approved: string[] = [];
      let recommended: string[] = [];
      if (data.approver) {
        for (let actioner of data.approver.split(',')) {
          if (actioner !== null && actioner !== '' && actioner !== undefined) {
            approver.push(actioner);
          }
        }
      }
      if (data.recommender) {
        for (let actioner of data.recommender.split(',')) {
          if (actioner !== null && actioner !== '' && actioner !== undefined) {
            recommender.push(actioner);
          }
        }
      }
      if (data.endorser) {
        for (let actioner of data.endorser.split(',')) {
          if (actioner !== null && actioner !== '' && actioner !== undefined) {
            endorser.push(actioner);
          }
        }
      }
      if (data.endorsed) {
        for (let actioner of data.endorsed.split(',')) {
          if (actioner !== null && actioner !== '' && actioner !== undefined) {
            endorsed.push(actioner);
          }
        }
      }
      if (data.releaser) {
        for (let actioner of data.releaser.split(',')) {
          if (actioner !== null && actioner !== '' && actioner !== undefined) {
            releaser.push(actioner);
          }
        }
      }
      if (data.approved) {
        for (let actioner of data.approved.split(',')) {
          if (actioner !== null && actioner !== '' && actioner !== undefined) {
            approved.push(actioner);
          }
        }
      }
      if (data.recommended) {
        for (let actioner of data.recommended.split(',')) {
          if (actioner !== null && actioner !== '' && actioner !== undefined) {
            recommended.push(actioner);
          }
        }
      }
      this.actioner = {
        approver: approver,
        recommender: recommender,
        endorser: endorser,
        endorsed: endorsed,
        releaser: releaser,
        approved: approved,
        recommended: recommended
      };
      this.actioner = await lastValueFrom(this.backendService.getCoveringOfficers(this.actioner));
    }
    catch (err) {
      console.log('Error in fetching the getCoveringOfficers ', err);
    }
  }

  async capitalBudgetAvailable(budgetfundCentreCode: string, GLAccountCode: string, BudgetOrderNo: string, deliveryDate:string) {
    try {
      const table_fp = environment.table_fp;
      const table_cb = environment.table_cb;
      var record: OthersBudget = await lastValueFrom(this.backendService.checkBudgetOTH(budgetfundCentreCode, "", GLAccountCode, BudgetOrderNo, deliveryDate, table_fp, table_cb));
      console.log("BUDGET_AVAL for Capital", record.BUDGET_AVAL)
      return Number(record.BUDGET_AVAL);
    } catch (err) {
      this.issapTimeout = true;
      console.log('Error in fetching the data from SAP ', err);
      return 0;
    }
  }
  formatDate(date: any): string {
    if (date) {
      return this.datePipe.transform(date, 'yyyyMMdd') ?? date;
    }
    return date;
  }
  async projectBudgetAvailable(wbsElement: string) {
    try {
      var record: WBSBudget = await lastValueFrom(this.backendService.checkBudgetProject(wbsElement));
      console.log("BUDGET_AVAL for Project", record.SGD_AVAILABLE)
      return record.SGD_AVAILABLE;
    } catch (err) {
      this.issapTimeout = true;
      console.log('Error in fetching the data from SAP ', err);
      return 0;
    }
  }

  async capitalBudgetAUCAvailable(wbsElement: string) {
    try {
      var record: WBSBudget = await lastValueFrom(this.backendService.checkBudgetCapitalAUC(wbsElement));
      console.log("BUDGET_AVAL for Project", record.SGD_AVAILABLE)
      return record.SGD_AVAILABLE;
    } catch (err) {
      this.issapTimeout = true;
      console.log('Error in fetching the data from SAP ', err);
      return 0;
    }
  }

  async generateProjectCompletionMessage(workflowHeaders: WorkflowHeader[]) {
    const budgetsNames: string[] = []
    for (const workflowHeader of workflowHeaders) {
      if (workflowHeader.budgetType !== 'Project' || !workflowHeader.budgetCostCentreCode) return
      const record: any = await lastValueFrom(this.backendService.getProjectVoteInfo(workflowHeader.budgetCostCentreCode))
      if (record.hashLastMinuteProjectEqupmentPurchase) {
        this.showProjectCompletionMessage = true
        budgetsNames.push(workflowHeader.budgetCostCentre)
      }
    }
    this.budgetNames = budgetsNames.join(', ')
  }
  async downloadAttactment(attachment: TenderDocumentAttachment) {
    try {
      let data: any = await lastValueFrom(
        this.backendService.downloadAttachment(
          attachment.AttachmentId?.toString() as string
        )
      );
      const arrayBuffer: any = data.attachment.data;
      const int8Array = new Uint8Array(arrayBuffer);
      let blob = new Blob([int8Array], { type: `application/json` });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = attachment.FileName;
      a.click();
      window.URL.revokeObjectURL(a.href);
    } catch (e) {
      alert('error downloading');
    }
  }
  async getWOCFiles(code: string) {
    if (code) {
      const wocFile = await lastValueFrom(
        this.backendService.getWocFile(code).pipe(
          takeUntil(this.destroy$)
        )
      );
      this.fileReference = wocFile.find(i => i.Code === this.ApprovingOfficerSummary.WaiverOfCompetition?.FileReferenceNumber);
    }
  }

  hasVendorDocument() {
    return this.ApprovingOfficerSummary.Attachment?.some(
      (item) => item.AttachmentTypeId === this.AttachmentTypeId.DOCUMENT_TO_VENDOR
    );
  }

  displayPurchaseMode(purchaseType: string) {
    switch (purchaseType) {
      case this.PurchaseTypeEnum.TENDER:
        return 'Tender Process';
      case this.PurchaseTypeEnum.ONLINE:
        return 'Corporate Credit Card Purchase';
      case this.PurchaseTypeEnum.DC:
        return 'Direct Contracting​';
      case this.PurchaseTypeEnum.PM:
        return 'Permissible Covering Purchase Order​';
      default:
        return purchaseType;
    }
  }

  isDisplayGEWCA() {
    return this.ApprovingOfficerSummary?.itemList?.some(item => !!item.IsGEWCA);
  }

  public get alertType(): typeof AlertType {
    return AlertType;
  }

  isDisplayDIRP() {
    const workflowId = this.currentWorkflow?.workflow_id ?? null;
    return this.ApprovingOfficerSummary.IsDIRP && ([WorflowHistory.CARApproval, WorflowHistory.CAPAUCApproval, WorflowHistory.OPSApproval, WorflowHistory.RESApproval] as string[]).includes(workflowId);
  }

  isDisplayRestrictedITProduct() {
    const workflowId = this.currentWorkflow?.workflow_id ?? null;

    return (
      (
        [
          WorflowHistory.CARApproval,
          WorflowHistory.CAPAUCApproval,
          WorflowHistory.OPSApproval,
          WorflowHistory.RESApproval,
        ] as string[]
      ).includes(workflowId) &&
      this.ApprovingOfficerSummary?.itemList?.some(
        (item) =>
          item.RestrictedITProductPolicy &&
          item.RestrictedITProductPolicy.toLowerCase().includes('cat')
      )
    );
  }

  getITProductPolicyNoticeObservable() {
    const isSD = this.ApprovingOfficerSummary?.itemList?.every(item => item.RestrictedITProductPolicy?.toLowerCase() === 'cat1')
    const isSDCDO = this.ApprovingOfficerSummary?.itemList?.some(item => item.RestrictedITProductPolicy?.toLowerCase() === 'cat2')
    if (isSD) {
      return this.noticeService.ITProductPolicyAOSDNotice$;
    } else if (isSDCDO) {
      return this.noticeService.ITProductPolicyAOSDCDONotice$;
    } else {
      // Fallback
      return this.noticeService.ITProductPolicyAOSDNotice$
    }
  }

  budgetAllocationContent(element: RoBudgetAllocationSummary) {
    const budgetInfoMap = {
      Operating: () => {
        return {
          expenditure: element.expenditure ? "Budgeted" : "Unbudgeted",
          exco: element.exco,
          frequency: element.frequency ? "Recurrent" : (element.expenditure ? "Non-recurrent" : "NA"),
          spaceReq: 'N/A',
          budgetCostCenter: element.costCentre
        };
      },
      Capital: () => {
        return {
          expenditure: element.expenditure ? "Budgeted" : "Unbudgeted",
          exco: element.exco,
          frequency: 'N/A',
          spaceReq: element.spaceReq ? "Yes" : "No",
          budgetCostCenter: element.fundCentre
        };
      },
      "Capital AUC": () => {
        return {
          expenditure: element.expenditure ? "Budgeted" : "Unbudgeted",
          exco: element.exco,
          frequency: 'N/A',
          spaceReq: element.spaceReq ? "Yes" : "No",
          budgetCostCenter: element.projectBudget
        };
      },
      Project: () => {
        return {
          expenditure: 'N/A',
          exco: 'N/A',
          frequency: 'N/A',
          spaceReq: 'N/A',
          budgetCostCenter: element.projectBudget
        };
      },
    };

    return budgetInfoMap[element.budgetType as keyof typeof budgetInfoMap]?.() || '';
  }

  async getSAPBudget(budgetSummaries: any) {
    let finalBudgetSummaries: RoBudgetAllocationSummary[] = []
    for (const budgetSummary of budgetSummaries) {
      let workflowHeader = this.findWorkflowHeaderForEachBudgetSummary(budgetSummary)
      if (workflowHeader) {
        let finalBudgetSummary = await this.returnWorkflowHeadersWithBudgetAvailabilityDetails(workflowHeader, budgetSummary)
        finalBudgetSummaries.push(finalBudgetSummary)
        this.isLoadingSAPData = false;
      }
    }
    this.newDataSource.data = finalBudgetSummaries
  }

  retrySAP() {
    this.isLoadingSAPData = true;
    this.issapTimeout = false;
    this.getSAPBudget(this.formattedBudgetSummaries);
  }



  toggleBudgetCellExpand(element: any): void {
    if (this.expandedBudgets.has(element)) {
      this.expandedBudgets.delete(element);
    } else {
      this.expandedBudgets.add(element);
    }
  }
  
  isBudgetCellExpanded(element: any): boolean {
    return this.expandedBudgets.has(element);
  }
  

  toggleAttachmentSelection(type: string) {
    if (this.selectedAttachments.has(type)) {
      this.selectedAttachments.delete(type);
    } else {
      this.selectedAttachments.add(type);
    }
  }

  isAttachmentSelected(type: string): boolean {
    return this.selectedAttachments.has(type);
  }

  get availableAttachments() {
    return this.allAttachmentTypes.filter(a => this.availableDocAttachments.includes(a.type));
  }

  setAvailableAttachments() {
    const purchaseType = this.ApprovingOfficerSummary.purchaseType;
    const expectedAttachments = this.ATTACHMENTS_BY_PURCHASE_TYPE[purchaseType] || [];
    const attachmentDataMap: { [key: string]: ScopeOfWorkAttachment[] } = {
      supporting: this.supportingDocumentAttachment,
      quotation: this.quotationDocumentAttachment,
      approvals: this.approvalDocumentAttachment,
      vendor: this.vendorDocumentAttachment,
      sow: this.scopeOfWorkAttachment,
      tender: this.tenderDocumentAttachment
    };
    this.availableDocAttachments = expectedAttachments.filter(type =>
      attachmentDataMap[type]?.length > 0
    );
  }

  setSelectedAttachments() {
    const validSelections = this.documentStatusAttachments.filter(type =>
      this.availableDocAttachments.includes(type)
    );

    const subStatus = this.ApprovingOfficerSummary.documentSubStatus.toLowerCase();

    const isPendingVD = subStatus.includes("pending vendor document");
    const isPendingSOW = subStatus.includes("pending sow");
    const isPendingTD = subStatus.includes("pending tender document");

    let finalSelections: string[] = [];

    if (isPendingVD && validSelections.includes('vendor')) {
      finalSelections = ['vendor'];
    } else if (isPendingSOW && validSelections.includes('sow')) {
      finalSelections = ['sow'];
    } else if (isPendingTD && validSelections.includes('tender')) {
      finalSelections = ['tender'];
    } else {
      finalSelections = validSelections;
    }

    this.selectedAttachments = new Set(finalSelections);
  }

}
interface RoBudgetAllocationSummary extends BudgetAllocationSummary {
  budgetAvailability: string
  exemptedAmount: string
  budgetBalance: string
  expenditure: boolean | null
  frequency: boolean | null
  exco: string | null
  spaceReq: number | null
}
interface CapitalUsageRequirement  {
  itemno: number | null
  budgetCostCentre: string | undefined
  itemDescription: string | undefined
  itemAmount: string | undefined
  IsAdditionalSpaceRequired: string | undefined
  AnnualMaintenanceCost: string | undefined
  IsSupportingNonFundingProject: string | undefined
  SupportingInformation: string | undefined
  BudgetType:string | undefined,
  EstimatedAsset:string | undefined
  }
  export interface IitemInfo {
    displayItemNumber:number;
    ItemDescription: string;
    TotalAmount: string;
    isDeleted:boolean;
    Strikethrough:boolean
    amountMaintenance: string,
    estimatedAsset: string,
    projectCofunding: string,
    reasonDescription: string,
    spaceRequirement: string,
    BudgetCode:string | undefined,
  }

interface itemBudgetInfo {
  ItemNo: number;
  MatSUbGrp: string;
  ItemDesc: string;
  PartNum: number;
  Qty: number;
  UoM: number;
  Currency: string;
  UnitPrice: number;
  itemAmount: number;
  BudgetsInvolved: BudgetItemGroup[];
  originalAllocations: any;
}

interface BudgetItemGroup {
  type: string;
  centre: string;
  gl: string;
  groupKey: string;
}
